import { Component, OnInit } from '@angular/core';
export class FormComponent implements OnInit {
constructor() { }
/**
 * @return {?}
 */
ngOnInit() {
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'app-form',
  template: `
    <div class="container">

      <h3>Form Test</h3>

      <div class="example-container">
        <mat-form-field>
          <input matInput placeholder="Input">
        </mat-form-field>
  
        <mat-form-field>
          <textarea matInput placeholder="Textarea"></textarea>
        </mat-form-field>
  
        <mat-form-field>
          <mat-select placeholder="Select">
            <mat-option value="option">Option</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
  
    </div>
  `,
  styles: [`
    .example-container {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
          -ms-flex-direction: column;
              flex-direction: column; }

    .example-container > * {
      width: 100%; }
  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function FormComponent_tsickle_Closure_declarations() {
/** @type {?} */
FormComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FormComponent.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
